// extracted by mini-css-extract-plugin
module.exports = {"th-details":"styles_th-details__Ou3b2","th-shim-details":"styles_th-shim-details__7EKUA","shimmer":"styles_shimmer__cgjFM"};